import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store/index'
import './style/base.scss'
import App from './App'
import ErrorBoundary from './components/error-boundary'
import ossConfig from './utils/configUrl'
console.log(ossConfig)
ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
)
